import jsKit from './jsKit';

const toggleOrderDetails = (e) => {
  const button = e?.delegateTarget || e?.currentTarget;
  if (!button) return;

  const visibility = button.dataset.jsToggleOrderDetails === '1';
  const orderDetails = document.getElementById('order-details');
  const showButton = document.getElementById('show-order-details');
  const hideButton = document.getElementById('hide-order-details');

  if (orderDetails) {
    orderDetails.style.display = visibility ? '' : 'none';
  }

  if (showButton) {
    showButton.style.display = visibility ? 'none' : '';
  }

  if (hideButton) {
    hideButton.style.display = visibility ? '' : 'none';
  }
};

export const orderDetailsEvents = [
  ['jsToggleOrderDetails', toggleOrderDetails],
];

export const registerOrderDetailsEvents = () => {
  orderDetailsEvents.forEach(([dataItem, handler, eventName]) => {
    jsKit.attachEventByDataSet(dataItem, handler, eventName);
  });
};
